import React, { Component } from 'react';
import { isEmailAlreadyExist } from '../service/UserService';
import {withRouter} from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';

class UserData extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            email: '',
            password: '', 
            password2: '',
            farmer_name: '',
            address_city: '',
            address_postcode: '',
            address_street: '',
            address_number: '',
            company_name: '',
            company_number: '',
            farm_size: '',
            farm_cultures: '',
            contact_telephone: '',
            contact_facebook: '',
            companyOrIndividual: 'Individual',
            accepted:false,
            isModification: false,
            errors:{},
            emailAlreadyRegistered: false,
            password1Visible: false,
            password2Visible: false
         }
    }

    componentDidMount(){
        //console.log("userData", this.props.userData);
        if (this.props.userData){
            let isModification = this.props.isModification ?? true;
            this.setState({...this.props.userData, isModification: isModification, accepted: isModification}, () =>{
                if(this.props.userData.company_name !== ''){
                    this.setState({companyOrIndividual: 'Individual'});
                }
            });
        }
    }

      /*
   `id` int(11) NOT NULL,
  `email` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `username` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `password` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `lastlogin` timestamp NOT NULL DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
  `created` timestamp NOT NULL DEFAULT '0000-00-00 00:00:00',
  `farmer_name` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `address_city` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `address_postcode` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `address_street` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `address_number` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `company_name` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `company_number` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `farm_size` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `farm_cultures` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `contact_telephone` varchar(255) COLLATE utf8_hungarian_ci NOT NULL,
  `contact_facebook` varchar(255) COLLATE utf8_hungarian_ci NOT NULL
 */
    handleSubmitClick = (e) =>{
        e.preventDefault();
        
        if(!this.validateForm()){
            return;
        }

        this.setState({errors:{}}, ()=>{
            //only submit after errors are set to zero
            this.props.handleSubmitClick(this.state);
        });
        //console.log('state:', this.state);
    }

    
    validateForm(){
        let errors = {};
        let formIsValid = true;
        
        if(!this.state.email){
            formIsValid = false;
            errors["email"] = "A mező kitöltése kötelező";
        }
        else if(!this.validateEmail(this.state.email)){
            formIsValid = false;
            errors["email"] = "Nem helyes email formátum";
        }
        if(this.state.emailAlreadyRegistered){
            formIsValid = false;
            errors["email"] = "Ez az email cím már regisztrálva van";
        }
        
        if(!this.state.password  && !this.state.isModification){
            formIsValid = false;
            errors["password"] = "A mező kitöltése kötelező";
        }
        if(!this.state.password2 && !this.state.isModification){
            formIsValid = false;
            errors["password2"] = "A mező kitöltése kötelező";
        }
        if((this.state.password2 && this.state.password && this.state.password2 !== this.state.password) ||
            (!this.state.password2 && this.state.password) ||
            (this.state.password2 && !this.state.password)){
            formIsValid = false;
            errors["password2"] = "A jelszavak nem egyeznek";
        }
        if(!this.state.farmer_name){
            formIsValid = false;
            errors["farmer_name"] = "A mező kitöltése kötelező";
        }
        if(!this.state.address_city){
            formIsValid = false;
            errors["address_city"] = "A mező kitöltése kötelező";
        }
        if(!this.state.address_postcode){
            formIsValid = false;
            errors["address_postcode"] = "A mező kitöltése kötelező";
        }
        if(!this.state.address_street){
            formIsValid = false;
            errors["address_street"] = "A mező kitöltése kötelező";
        }
        if(!this.state.address_number){
            formIsValid = false;
            errors["address_number"] = "A mező kitöltése kötelező";
        }
        if(!this.state.contact_telephone){
            formIsValid = false;
            errors["contact_telephone"] = "A mező kitöltése kötelező";
        }
        // if(!this.state.contact_facebook){
        //     formIsValid = false;
        //     errors["contact_facebook"] = "A mező kitöltése kötelező";
        // }
        
        this.setState({errors: errors});
        return formIsValid;
    }

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    onChangeRadioButton = (e) =>{
        //console.log("onChangeRadioButton", e.target.value);
        this.setState({companyOrIndividual: e.target.value});
        
    }

    checkEmail = (e) =>{
        //console.log("check email:" + e.target.value);
        isEmailAlreadyExist(e.target.value).then((responseJson)=>{
            //console.log("check email response:", responseJson);
            this.setState({emailAlreadyRegistered: responseJson.status});
            if(responseJson.status){
                this.setState({errors: {...this.state.errors, email: "Ez az email cím már regisztrálva van!"}});
            }
        });
    }

    setPhoneNumber = (e) =>{
        const value = e.target.value.replace(/\D/g, "");
        this.setState({[e.target.name]: value});
        /*
        const re = /^[0-9\b]+$/;

        // if value is not blank, then test the regex

        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({[e.target.name]: e.target.value})
        }*/
    }

    handleBackClick = (e) =>{
        this.props.history.push("/fooldal");
    }

    togglePasswordVisibility = () => {
        this.setState({password1Visible: !this.state.password1Visible});
    };
    togglePassword2Visibility = () => {
        this.setState({password2Visible: !this.state.password2Visible});
    };

    render() { 
        return ( 
        <div id="kwizda-userdata" className="kwizda-form row" style={{width:'100%', margin:'auto'}}>
            <div className="kwizda-form-column col-6 login-card mt-2 hv-center">
                <div className="card">
                    <h4>Felhasználói fiók</h4>
                    <label>E-mail</label>
                    <input onBlur={(e)=>{this.checkEmail(e)}} className={this.state.errors["email"]?"kwizda-form-invalid":""}
                        type="text" value={this.state.email} disabled={this.state.isModification && this.props.userData}
                        name="email" placeholder="E-mail"
                        onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                    <span style={{color: "red"}}>{this.state.errors["email"]}</span>
                    {this.state.isModification &&
                    <div style={{display:'inline-grid'}}>
                        {(this.state.companyOrIndividual==='Company')?
                        <label>Kapcsolattartó neve</label>:
                        <label>Név</label>}
                        <input className={this.state.errors["farmer_name"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.farmer_name} name="farmer_name" placeholder="Termelő/kapcsolattartó neve"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                        <span style={{color: "red"}}>{this.state.errors["farmer_name"]}</span>
                    </div>
                    }
                    {this.state.isModification &&<h4>Jelszó módosítása</h4>}
                    <label>Jelszó</label>
                    <div className="password-input-container">
                        <input className={this.state.errors["password"]?"kwizda-form-invalid":""}
                            type={this.state.password1Visible ? 'text' : 'password'} value={this.state.password} name="password" placeholder="Jelszó"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                            <span className="toggle-visibility" onClick={this.togglePasswordVisibility}>
                                {this.state.password1Visible ? <EyeOff size={18} /> : <Eye size={18} />}
                            </span>
                    </div>
                    <span style={{color: "red"}}>{this.state.errors["password"]}</span>
                    <label>Jelszó ismétlése</label>
                    <div className="password-input-container">
                        <input className={this.state.errors["password2"]?"kwizda-form-invalid":""}
                            type={this.state.password2Visible ? 'text' : 'password'} value={this.state.password2} name="password2" placeholder="Jelszó ismétlése"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                            <span className="toggle-visibility" onClick={this.togglePassword2Visibility}>
                                {this.state.password2Visible ? <EyeOff size={18} /> : <Eye size={18} />}
                            </span>
                    </div>
                    <span style={{color: "red"}}>{this.state.errors["password2"]}</span>
                    {!this.state.isModification &&
                    <div style={{display:'inline-grid'}}>
                        <h4>Név</h4>
                        <input className={this.state.errors["farmer_name"]?"kwizda-form-invalid":""}
                            type="text" value={this.state.farmer_name} name="farmer_name" placeholder="Név"
                            onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                        <span style={{color: "red"}}>{this.state.errors["farmer_name"]}</span>
                    </div>
                    }
                    
                </div>
            </div>
            <div className="kwizda-form-column col-6 login-card mt-2 hv-center">
                <div className="card">
                    <h4>Cím</h4>
                    <label>Település</label>
                    <input className={this.state.errors["address_city"]?"kwizda-form-invalid":""}
                        type="text" value={this.state.address_city} name="address_city" placeholder="Település"
                        onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                    <span style={{color: "red"}}>{this.state.errors["address_city"]}</span>
                    <label>Irányítószám</label>
                    <input className={this.state.errors["address_postcode"]?"kwizda-form-invalid":""}
                        type="text" value={this.state.address_postcode} name="address_postcode" placeholder="Irányítószám"
                        onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                    <span style={{color: "red"}}>{this.state.errors["address_postcode"]}</span>
                    <label>Utca</label>
                    <input className={this.state.errors["address_street"]?"kwizda-form-invalid":""}
                        type="text" value={this.state.address_street} name="address_street" placeholder="Utca"
                        onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                    <span style={{color: "red"}}>{this.state.errors["address_street"]}</span>
                    <label>Házszám</label>
                    <input className={this.state.errors["address_number"]?"kwizda-form-invalid":""}
                        type="text" value={this.state.address_number} name="address_number" placeholder="Házszám"
                        onChange={(e) => this.setState({[e.target.name]: e.target.value})}></input>
                    <span style={{color: "red"}}>{this.state.errors["address_number"]}</span>
                    <h4>Elérhetőségek</h4>
                    <label>Telefon</label>
                    <input className={this.state.errors["contact_telephone"]?"kwizda-form-invalid":""}
                        type="text" value={this.state.contact_telephone} name="contact_telephone" placeholder="Telefon"
                        onChange={(e) => this.setPhoneNumber(e)}></input>
                    <span style={{color: "red"}}>{this.state.errors["contact_telephone"]}</span>
                    <div>
                        <button
                            className="kwizda-button kwizda-userdata-button"
                            type="submit" 
                            onClick={(e)=>this.handleSubmitClick(e)}
                        >
                            {!this.props.fullRegistration? "Mentés" : "Tovább"}
                        </button>
                        {(!this.props.fullRegistration)
                        ?<button type="button" 
                                    className=" kwizda-back-button kwizda-userdata-back-button"
                                    onClick={(e) => this.handleBackClick(e)}
                        >Vissza</button>
                        :
                        ""
                        }
                    </div>
                </div>
            </div>
        </div> );
    }
   
}
 
export default withRouter(UserData);